import { render, staticRenderFns } from "./ESGscore.vue?vue&type=template&id=7877e78a"
import script from "./ESGscore.vue?vue&type=script&lang=js"
export * from "./ESGscore.vue?vue&type=script&lang=js"
import style0 from "./ESGscore.vue?vue&type=style&index=0&id=7877e78a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports